// extracted by mini-css-extract-plugin
module.exports = {"searchWarp":"searchWarp--238D_","tabs":"tabs--3uf-Q","tab":"tab--2StKn","active":"active--2XaUV"};